import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["fill"];
var _rect, _path, _svg, _rect2, _path2;
import * as React from 'react';
import { SvgIcon, useTheme } from '@lumahealthhq/ui-core';
import createSvgImage from './createSvgImage';

// TODO lucasOliveira use `createSvgIcon`
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var IconLumiOutlinedCustom = createSvgImage(/*#__PURE__*/_jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#clip0_428_1385)",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M12.6667 6.00008L13.5 4.16675L15.3334 3.33341L13.5 2.50008L12.6667 0.666748L11.8334 2.50008L10 3.33341L11.8334 4.16675L12.6667 6.00008Z",
      fill: "url(#paint0_linear_428_1385)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.6667 10.0001L11.8334 11.8334L10 12.6667L11.8334 13.5001L12.6667 15.3334L13.5 13.5001L15.3334 12.6667L13.5 11.8334L12.6667 10.0001Z",
      fill: "url(#paint1_linear_428_1385)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.66669 6.33341L6.00002 2.66675L4.33335 6.33341L0.666687 8.00008L4.33335 9.66675L6.00002 13.3334L7.66669 9.66675L11.3334 8.00008L7.66669 6.33341ZM6.66002 8.66008L6.00002 10.1134L5.34002 8.66008L3.88669 8.00008L5.34002 7.34008L6.00002 5.88675L6.66002 7.34008L8.11335 8.00008L6.66002 8.66008Z",
      fill: "url(#paint2_linear_428_1385)"
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("linearGradient", {
      id: "paint0_linear_428_1385",
      x1: "0.666687",
      y1: "0.666748",
      x2: "15.8578",
      y2: "0.892095",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#7F14EE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.515",
        stopColor: "#D62EA9"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#F36C23"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint1_linear_428_1385",
      x1: "0.666687",
      y1: "0.666748",
      x2: "15.8578",
      y2: "0.892095",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#7F14EE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.515",
        stopColor: "#D62EA9"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#F36C23"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint2_linear_428_1385",
      x1: "0.666687",
      y1: "0.666748",
      x2: "15.8578",
      y2: "0.892095",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#7F14EE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.515",
        stopColor: "#D62EA9"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#F36C23"
      })]
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "clip0_428_1385",
      children: /*#__PURE__*/_jsx("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    })]
  })]
}), 'IconLumiOutlinedCustom', 16, 16);

// TODO lucasOliveira use `createSvgIcon`
export var IconLumiCustom = createSvgImage(/*#__PURE__*/_jsxs("g", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none",
  children: [/*#__PURE__*/_jsx("rect", {
    width: "38",
    height: "38",
    x: "1",
    y: "1",
    fill: "#fff",
    rx: "19"
  }), /*#__PURE__*/_jsx("rect", {
    width: "38",
    height: "38",
    x: "1",
    y: "1",
    stroke: "url(#a)",
    strokeWidth: "2",
    rx: "19"
  }), /*#__PURE__*/_jsxs("g", {
    clipPath: "url(#b)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "url(#c)",
      d: "m25.833 17.5 1.042-2.292 2.292-1.041-2.292-1.042-1.042-2.292-1.041 2.292-2.292 1.042 2.292 1.041 1.041 2.292Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "url(#d)",
      d: "m25.833 22.5-1.041 2.292-2.292 1.041 2.292 1.042 1.041 2.292 1.042-2.292 2.292-1.042-2.292-1.041-1.042-2.292Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "url(#e)",
      d: "M19.583 17.917 17.5 13.333l-2.083 4.584L10.833 20l4.584 2.083 2.083 4.584 2.083-4.584L24.167 20l-4.584-2.083Zm-1.258 2.908-.825 1.817-.825-1.817L14.858 20l1.817-.825.825-1.817.825 1.817 1.817.825-1.817.825Z"
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("linearGradient", {
      id: "a",
      x1: "0",
      x2: "41.43",
      y1: "0",
      y2: ".615",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#7F14EE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#D62EA9"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "c",
      x1: "10.833",
      x2: "29.822",
      y1: "10.833",
      y2: "11.115",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#7F14EE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#D62EA9"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "d",
      x1: "10.833",
      x2: "29.822",
      y1: "10.833",
      y2: "11.115",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#7F14EE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#D62EA9"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "e",
      x1: "10.833",
      x2: "29.822",
      y1: "10.833",
      y2: "11.115",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#7F14EE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#D62EA9"
      })]
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "b",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M10 10h20v20H10z"
      })
    })]
  })]
}), 'IconLumiCustom', 40, 40);
export function IconBrowserUpdated(props) {
  return /*#__PURE__*/_jsxs(SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props, {
    children: [_rect || (_rect = /*#__PURE__*/_jsx("rect", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      height: "24",
      width: "24",
      y: "0"
    })), _path || (_path = /*#__PURE__*/_jsx("path", {
      xmlns: "http://www.w3.org/2000/svg",
      d: "M22,13v3c0,1.1-0.9,2-2,2h-3l1,1v2H6v-2l1-1H4c-1.1,0-2-0.9-2-2V5c0-1.1,0.9-2,2-2l8,0v2L4,5v11h16v-3H22z M15,15l-5-5h4V3 h2v7h4L15,15z"
    }))]
  }));
}
export function IconDemographics(props) {
  return /*#__PURE__*/_jsx(SvgIcon, _extends({}, props, {
    children: _svg || (_svg = /*#__PURE__*/_jsxs("svg", {
      height: "24px",
      viewBox: "0 0 24 24",
      width: "24px",
      children: [/*#__PURE__*/_jsx("rect", {
        fill: "none",
        height: "24",
        width: "24"
      }), /*#__PURE__*/_jsx("g", {
        children: /*#__PURE__*/_jsx("path", {
          d: "M12,12.75c1.63,0,3.07,0.39,4.24,0.9c1.08,0.48,1.76,1.56,1.76,2.73L18,18H6l0-1.61c0-1.18,0.68-2.26,1.76-2.73 C8.93,13.14,10.37,12.75,12,12.75z M4,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2C2,12.1,2.9,13,4,13z M5.13,14.1 C4.76,14.04,4.39,14,4,14c-0.99,0-1.93,0.21-2.78,0.58C0.48,14.9,0,15.62,0,16.43V18l4.5,0v-1.61C4.5,15.56,4.73,14.78,5.13,14.1z M20,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2C18,12.1,18.9,13,20,13z M24,16.43c0-0.81-0.48-1.53-1.22-1.85 C21.93,14.21,20.99,14,20,14c-0.39,0-0.76,0.04-1.13,0.1c0.4,0.68,0.63,1.46,0.63,2.29V18l4.5,0V16.43z M12,6c1.66,0,3,1.34,3,3 c0,1.66-1.34,3-3,3s-3-1.34-3-3C9,7.34,10.34,6,12,6z"
        })
      })]
    }))
  }));
}
export function IconSocialHistory(props) {
  return /*#__PURE__*/_jsxs(SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props, {
    children: [_rect2 || (_rect2 = /*#__PURE__*/_jsx("rect", {
      fill: "none",
      height: "24",
      width: "24"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M6,3l0,6c0,2.97,2.16,5.43,5,5.91V19H8v2h8v-2h-3v-4.09c2.84-0.48,5-2.94,5-5.91l0-6H6z M16,8H8l0-3h8C16,5,16,8,16,8z"
    }))]
  }));
}
export function IconSignature(_ref) {
  var fill = _ref.fill,
    other = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  return /*#__PURE__*/_jsxs(SvgIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, other, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10 0V10.375L5.8125 6.1875L3 9L12 18.0625L21.0625 9L18.1875 6.1875L14 10.375V0H10Z",
      fill: fill || theme.palette.primary.main
    }), /*#__PURE__*/_jsx("rect", {
      y: "20",
      width: "24",
      height: "4",
      fill: fill || theme.palette.primary.main
    })]
  }));
}